import { Outlet } from "react-router-dom";

const BrandsDash = () => {
  return (
    <div>
      <Outlet />
    </div>
  );
};

export default BrandsDash;
